
import { Component } from 'vue-property-decorator';
import { InputType } from '@/enums/InputType';
import { mixins } from 'vue-class-component';
import StackedForm from '@/mixins/StackedForm';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import { Venue } from '@/interfaces/models/Venue';
import { Licence } from '@/interfaces/models/Licence';
import { Hardware } from '@/interfaces/models/Hardware';

@Component({
  components: { VFormBuilder },
})
export default class FinancesForm extends mixins(StackedForm) {
  public $refs!: {
    mainForm: InstanceType<typeof VFormBuilder> & { form: any };
    licencesForm: InstanceType<typeof VFormBuilder> & { form: any };
    hardwareForm: InstanceType<typeof VFormBuilder> & { form: any };
  };

  public hardwareList: Hardware[] = [];
  public dataInitiated: boolean = false;

  get initVals(): Venue {
    return (this.initialValues as any) || {};
  }

  get initLicencesVals(): Licence {
    return this.initVals.licences || {};
  }

  get initHardwareVals(): Hardware[] {
    return this.initVals.hardware || [];
  }

  get mainItems() {
    return [
      {
        name: 'customerNumber',
        type: InputType.Text,
        label: 'venue.form.finances.customerNumber',
        autocomplete: 'off',
      },
    ];
  }

  get licencesItems() {
    return [
      {
        name: 'sot',
        type: InputType.Text,
        label: 'venue.form.finances.sot',
        autocomplete: 'off',
        rules: 'integer|greater_than:0',
      },
      {
        name: 'sco',
        type: InputType.Text,
        label: 'venue.form.finances.sco',
        autocomplete: 'off',
        rules: 'integer|greater_than:0',
      },
      {
        name: 'operator',
        type: InputType.Text,
        label: 'venue.form.finances.operator',
        autocomplete: 'off',
        rules: 'integer|greater_than:0',
      },
      {
        name: 'pickup',
        type: InputType.Text,
        label: 'venue.form.finances.pickup',
        autocomplete: 'off',
        rules: 'integer|greater_than:0',
      },
      {
        name: 'driveIn',
        type: InputType.Text,
        label: 'venue.form.finances.driveIn',
        autocomplete: 'off',
        rules: 'integer|greater_than:0',
      },
      {
        name: 'menuboard',
        type: InputType.Text,
        label: 'venue.form.finances.menuboard',
        autocomplete: 'off',
        rules: 'integer|greater_than:0',
      },
      {
        name: 'custom',
        type: InputType.Text,
        label: 'venue.form.finances.custom',
        autocomplete: 'off',
      },
    ];
  }

  get hardwareItems() {
    return [
      {
        name: 'count',
        type: InputType.Text,
        label: 'venue.form.finances.count',
        autocomplete: 'off',
        rules: 'required|integer|greater_than:0',
      },
      {
        name: 'rentStartedAt',
        type: InputType.DateTime,
        label: 'venue.form.finances.rentStartedAt',
        rules: 'required',
        onlyDate: true,
      },
      {
        name: 'rentEndedAt',
        type: InputType.DateTime,
        label: 'venue.form.finances.rentEndedAt',
        rules: 'required',
        onlyDate: true,
      },
    ];
  }

  public initHardware() {
    this.hardwareList.push({
      count: undefined,
      rentStartedAt: undefined,
      rentEndedAt: undefined,
    });
  }

  public removeHardware(index: number) {
    this.hardwareList.splice(index, 1);
  }

  public initData() {
    this.dataInitiated = true;
    this.hardwareList = [...this.initHardwareVals];
  }

  public getData() {
    const hardwareRefs = this.$refs.hardwareForm as any;
    const hardwareRefsArray = !hardwareRefs ? [] : Array.isArray(hardwareRefs) ? hardwareRefs : [hardwareRefs];
    const hardwareFallback = !this.dataInitiated ? this.initHardwareVals : [];

    const hardware = !hardwareRefsArray.length
      ? hardwareFallback
      : hardwareRefsArray.map((ref: any) => ({ ...(ref.form || {}) }));
    const licences = this.$refs.licencesForm.form || {};

    return {
      ...this.$refs.mainForm.form,
      hardware,
      licences,
    };
  }
}
